import * as THREE from "three";
import {ExtrudeGeometry} from "three";

export function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

export function twistGeometryV2(geometry: ExtrudeGeometry, height: number, twistAmount: number, sideFunc = (_: number) => 0) {
    if(twistAmount === 0 && !sideFunc) {
        return geometry;
    }

    const quaternion = new THREE.Quaternion()
    const positions = geometry.attributes.position

    for (let i = 0; i < positions.count; i++) {
        // Calculate the twist factor based on the y position of the vertex
        const vertex = new THREE.Vector3()
        vertex.fromBufferAttribute(positions, i)
        const twistFactor = (vertex.z / height) * twistAmount

        // Apply the twist
        quaternion.setFromAxisAngle(new THREE.Vector3(0, 0, 1), twistFactor)
        vertex.applyQuaternion(quaternion)

        // Apply side function
        const scalar = sideFunc(vertex.z)

        const distance = new THREE.Vector2(vertex.x, vertex.y)
        const newDistance = distance.multiplyScalar(1 + scalar / distance.length())

        positions.setXYZ(i, newDistance.x, newDistance.y, vertex.z)
    }

    // Important: Notify Three.js that the vertices of the geometry have changed
    // geometry.verticesNeedUpdate = true

    return geometry
}

export const findPoint = (radial: number, radius: number) => {
    const X = radius * Math.cos(radial)
    const Y = radius * Math.sin(radial)

    return new THREE.Vector2(X, Y)
}

export const createShape = (points: any[], count: number, radius: number) => {
    const shapeRadialWidth = (Math.PI * 2) / count

    let circleShape = new THREE.Shape()

    circleShape = circleShape.moveTo(radius, 0) //TODO - check

    for (let i = 0; i < count; i++) {
        const startRadial = shapeRadialWidth * i
        const endRadial = shapeRadialWidth * (i + 1)

        // Calculate beginning coordinates
        const start = findPoint(startRadial, radius)

        // Calculate end coordinates
        const end = findPoint(endRadial, radius)

        // This is simplification
        const xStep = shapeRadialWidth / points[points.length - 1].x
        const scale = start.distanceTo(end) / points[points.length - 1].x

        for (let j = 1; j < points.length - 1; j++) {
            const point = points[j]
            const pointRadial = shapeRadialWidth * i + point.x * xStep
            const pointHeight = radius + point.y * scale

            // Calculate point coordinates
            const pointPosition = findPoint(pointRadial, pointHeight)

            circleShape = circleShape.lineTo(pointPosition.x, pointPosition.y)
        }

        circleShape = circleShape.lineTo(end.x, end.y)
    }

    return circleShape
}